import {
  narusBlue,
  narusGreen,
  narusRed
} from '../../components/shared/NarusMaterial/colors.js'

export default [
  {
    label: 'Improving',
    icon: 'fa fa-arrow-up',
    style: { color: narusGreen },
    value: 'ahead-of-target'
  },
  {
    label: 'Unchanged',
    icon: 'fa fa-arrow-right',
    style: { color: narusBlue },
    value: 'on-target'
  },
  {
    label: 'Worsening',
    icon: 'fa fa-arrow-down',
    style: { color: narusRed },
    value: 'behind-target'
  }
]
